module.exports = __webpack_public_path__ + "img/nouse.b0089db1.png";